import { Query } from "src/app/shared/ddd/models/query";

export class ItemsLightQuery implements Query {
  inspectionId: string;

  constructor(inspectionId: string) {
    this.inspectionId = inspectionId;
  }
}
